import { MuiFileInput } from 'mui-file-input';
import React, { useState, useEffect, useRef } from 'react';
import { withJsonFormsControlProps } from '@jsonforms/react';
import {
  FormHelperText,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Box,
  Typography,
  TextField,
  Button,
  SvgIcon
} from '@mui/material';
import { grey } from '@mui/material/colors';
// Redundant import removed
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { download_file } from '../../../store/job/jobSlice';
import AddToBrandModal from './AddToBrandModal';
import PdfThumbnail from './PdfThumbnail';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
// Redundant import removed

const LibraryAddSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2h11a2 2 0 0 1 2 2v11" />
      <path d="M2 4h11a2 2 0 0 1 2 2v11" />
      <path d="M0 6h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="white" />
      <circle cx="16" cy="16" r="6" fill="white" />
      <path d="M16 13v6" />
      <path d="M13 16h6" />
    </g>
  </SvgIcon>
);

const LibraryAddedSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2h11a2 2 0 0 1 2 2v11" />
      <path d="M2 4h11a2 2 0 0 1 2 2v11" />
      <path d="M0 6h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="white" />
      <circle cx="16" cy="16" r="6" fill="white" />
      <path d="M13.5 16l2 2 3-3.5" />
    </g>
  </SvgIcon>
);

const DeleteSvgIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2m-6 5v6m4-6v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const SendSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 2L11 13" />
      <path d="M22 2L15 22L11 13L2 9L22 2Z" />
    </g>
  </SvgIcon>
);

const IMAGE_REGEX = new RegExp('\\.(jpeg|jpg|gif|png|webp)($|\\?)', 'i');
const PDF_REGEX = new RegExp('\\.pdf($|\\?)', 'i');

const isImage = (url) => {
  if (!url || typeof url !== 'string') return false;
  return IMAGE_REGEX.test(url.split('?')[0]);
};

const isPdf = (url) => {
  if (!url || typeof url !== 'string') return false;
  return PDF_REGEX.test(url.split('?')[0]);
};

const getFullUrl = (path) => {
  if (!path || typeof path !== 'string') return null;
  if (path.startsWith('blob:') || path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const LINODE_BUCKET = 'sewrobj';
  const LINODE_REGION = 'us-east-1';
  return encodeURI(
    `https://${LINODE_BUCKET}.${LINODE_REGION}.linodeobjects.com/${path.replace(/^\/+/, '')}`
  );
};

const getFileNameClean = (f) => {
  if (!f) return "";
  if (f._originalName) return f._originalName;
  if (f.name && typeof f.name === 'string') return f.name;

  const actualFile = f.file || f;
  if (!actualFile) return "file";

  if (actualFile instanceof File) return actualFile.name;
  if (typeof actualFile === "string") {
    const clean = actualFile.split("?")[0];
    return clean.split("/").pop();
  }
  return "file";
};

export const FileWidget = ({ data, handleChange, path, schema, uischema, showBrandOption = false, showLibraryLink = false, proof_log_data, job_id, onOpenLibrary, enabled, label, variant = "standard", compact = false, labelBg = "white", logoName = "" }) => {
  const dispatch = useDispatch();
  const jobId = job_id;
  const isCompleted = showBrandOption && !path.includes('submitted');

  const [openBrandModal, setOpenBrandModal] = useState(false);
  const [selectedFileForBrand, setSelectedFileForBrand] = useState(null);
  const [linkInput, setLinkInput] = useState("");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const fileInputRef = useRef(null);

  const proofLogData = proof_log_data || [];

  const normalizeValue = (val) => {
    if (!val || !Array.isArray(val)) return [];

    return val.map((item) => {
      const fileUrl = typeof item === "string" ? item : (item?.file || "");
      if (!fileUrl) return typeof item === 'object' ? item : { file: item, add_to_brand: false };

      let uBase = "";
      if (typeof fileUrl === 'string') {
        const cleanURL = decodeURIComponent(fileUrl).split('?')[0];
        uBase = cleanURL.split('/').pop();
      } else if (fileUrl instanceof File) {
        uBase = fileUrl.name;
      }

      const prooflog = proofLogData.find((p) => {
        if (!p.file_path || !uBase) return false;
        const cleanP = decodeURIComponent(p.file_path).split('?')[0];
        const pBase = cleanP.split('/').pop();
        return pBase === uBase;
      });

      return {
        ...(typeof item === 'object' ? item : {}),
        file: fileUrl,
        add_to_brand: (typeof item === 'object' ? item.add_to_brand : false) || prooflog?.in_brand_library || false,
        prooflog_id: (typeof item === 'object' ? item.prooflog_id : null) || prooflog?.id || null,
        status: (typeof item === 'object' ? item.status : null) || prooflog?.sent_approved_files || null,
        name: (typeof item === 'object' ? item.name : "") || prooflog?.name || "",
        search_param: (typeof item === 'object' ? item.search_param : "") || prooflog?.search_param || "",
        is_personal: (typeof item === 'object' ? item.is_personal : false) || prooflog?.is_personal || false
      };
    });
  };

  const [files, setFiles] = useState(normalizeValue(data));

  useEffect(() => {
    setFiles(normalizeValue(data));
  }, [data, proof_log_data]);

  const handleBrandStatusChange = (isBranded, metadata) => {
    if (!selectedFileForBrand) return;

    const updated = [...files];
    if (selectedFileForBrand.index !== -1) {
      updated[selectedFileForBrand.index] = {
        ...updated[selectedFileForBrand.index],
        add_to_brand: isBranded,
        name: metadata?.name || "",
        search_param: metadata?.search_param || "",
        is_personal: metadata?.is_personal ?? false,
        folder_id: metadata?.folder_id,
        new_folder_name: metadata?.new_folder_name
      };
      setFiles(updated);
      if (typeof handleChange === 'function') handleChange(path, updated);
    }
  };

  const handleOpenBrandModal = (item, index) => {
    const fileName = getFileNameClean(item);
    setSelectedFileForBrand({
      index,
      prooflog_id: item.prooflog_id,
      fileName,
      name: item.name,
      logo_name: logoName,
      search_param: item.search_param,
      is_personal: item.is_personal,
      inBrand: item.add_to_brand,
      file: item.file
    });
    setOpenBrandModal(true);
  };

  const handleDownloadFile = async (item) => {
    try {
      const file = item.file;
      if (!file) return;
      const fileName = getFileNameClean(item);
      const fileKey = file.replace(/^\/+/, "");
      const directUrl = getFullUrl(file);

      if (jobId) {
        const action = await dispatch(
          download_file({
            job_id: jobId,
            file_key: fileKey,
            d_type: "attachment"
          })
        );
        const finalUrl = action.payload?.data?.url || action.payload?.url;
        if (finalUrl) {
          const link = document.createElement("a");
          link.href = finalUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        }
      }

      if (directUrl) {
        const link = document.createElement("a");
        link.href = directUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handleFileChange = (newFilesRaw) => {
    const uploaded = Array.from(newFilesRaw).map((f) => ({
      file: f,
      _originalName: f.name
    }));
    const updated = [...files, ...uploaded];
    const unique = updated.filter(
      (f, i, arr) =>
        i === arr.findIndex((x) => getFileNameClean(x) === getFileNameClean(f))
    );
    setFiles(unique);
    if (typeof handleChange === 'function') handleChange(path, unique);
  };

  const handleDeleteFile = (index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      const updated = files.filter((_, i) => i !== index);
      setFiles(updated);
      if (typeof handleChange === 'function') handleChange(path, updated);
    }
  };

  const handleAddLink = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!linkInput.trim()) return;
    const updated = [...files, { file: linkInput.trim() }];
    setFiles(updated);
    if (typeof handleChange === 'function') handleChange(path, updated);
    setLinkInput("");
  };

  const Demo = styled('div')(() => ({
    backgroundColor: 'transparent',
  }));

  /* ===== COMPACT VIEW (Single Line) ===== */
  if (compact) {
    const handleCompactClick = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    // Calculate display value
    const displayValue = files.length > 0
      ? files.map(f => getFileNameClean(f)).join(', ')
      : "";

    return (
      <Box sx={{ width: '100%', mb: 0 }}>
        {enabled !== false ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 0.5 }}>
            <input
              type="file"
              multiple
              hidden
              ref={fileInputRef}
              onChange={(e) => {
                if (e.target.files?.length) {
                  handleFileChange(e.target.files);
                }
                e.target.value = ""; // Reset
              }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <TextField
                onClick={handleCompactClick}
                size="small"
                variant="outlined"
                label={label || schema.title || " "}
                InputLabelProps={{ shrink: true, sx: { bgcolor: labelBg, px: 0.5 } }}
                fullWidth
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%', gap: 0.5, py: 0.5 }}>
                      <AttachFileIcon fontSize="small" sx={{ color: 'text.secondary', transform: 'rotate(45deg)', mt: 0.5, flexShrink: 0 }} />
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1, minWidth: 0 }}>
                        {files.map((f, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.25,
                              bgcolor: 'transparent',
                              borderRadius: '4px',
                              px: 0.5,
                              py: 0.1,
                              flexShrink: 0,
                              width: 'calc(50% - 4px)',
                              maxWidth: 'calc(50% - 4px)',
                              overflow: 'hidden'
                            }}
                          >
                            <Tooltip title={getFileNameClean(f)}>
                              <Typography
                                variant="caption"
                                sx={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  color: 'primary.main',
                                  fontWeight: 500,
                                  flex: 1,
                                  '&:hover': { textDecoration: 'underline' }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownloadFile(f);
                                }}
                              >
                                {getFileNameClean(f)}
                              </Typography>
                            </Tooltip>
                            <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                              {isCompleted && (
                                <Tooltip title={`${f.add_to_brand ? 'Manage' : 'Add'} to Library`}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => { e.stopPropagation(); handleOpenBrandModal(f, idx); }}
                                    sx={{ p: 0, color: f.add_to_brand ? '#05640a' : 'inherit' }}
                                  >
                                    {f.add_to_brand ? <LibraryAddedSvgIcon sx={{ fontSize: 13 }} /> : <LibraryAddSvgIcon sx={{ fontSize: 13 }} />}
                                  </IconButton>
                                </Tooltip>
                              )}
                              <IconButton
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDeleteFile(idx); }}
                                sx={{ p: 0, color: 'error.main' }}
                              >
                                <CloseIcon sx={{ fontSize: 13 }} />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ),
                  sx: { cursor: 'pointer' }
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    cursor: 'pointer',
                    minHeight: '38px',
                    paddingLeft: '8px'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: 0,
                    width: 0 // Hide the actual input text area to prevent interference
                  }
                }}
              />
            </Box>
          </Box>
        ) : (
          // READ-ONLY COMPACT VIEW
          <Box
            sx={{
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: '4px',
              pt: '10px',
              pb: '6px',
              minHeight: '40px',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 0.5,
              position: 'relative',
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }}
          >
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                top: '-9px',
                left: '8px',
                bgcolor: labelBg, 
                px: 0.5,
                fontSize: '0.65rem', // Match renderBrandLibraryField
                color: 'rgba(0, 0, 0, 0.6)',
                zIndex: 1,
                lineHeight: 1,
                whiteSpace: 'nowrap'
              }}
            >
              {label || schema.title || " "}
            </Typography>
            <AttachFileIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary', transform: 'rotate(45deg)', flexShrink: 0, mt: '2px' }} />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1, minWidth: 0 }}>
              {files.length > 0 ? (
                files.map((f, index) => (
                  <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.25, width: 'calc(50% - 4px)', maxWidth: 'calc(50% - 4px)', overflow: 'hidden' }}>
                    <Tooltip title={getFileNameClean(f)}>
                      <Typography
                        variant="body2"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownloadFile(f);
                        }}
                        sx={{
                          cursor: 'pointer',
                          color: '#1976d2',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          flex: 1,
                          fontSize: '0.75rem',
                          '&:hover': {
                            textDecoration: 'underline'
                          }
                        }}
                      >
                        {getFileNameClean(f)}
                      </Typography>
                    </Tooltip>
                    {/* Brand library icon to the right of the file name */}
                    {isCompleted && (
                      <Tooltip title={f.add_to_brand ? 'Manage in Library' : 'Add to Library'}>
                        <IconButton
                          size="small"
                          onClick={(e) => { e.stopPropagation(); handleOpenBrandModal(f, index); }}
                          sx={{ p: 0.25, color: f.add_to_brand ? '#05640a' : 'inherit' }}
                        >
                          {f.add_to_brand
                            ? <LibraryAddedSvgIcon sx={{ fontSize: 18 }} />
                            : <LibraryAddSvgIcon sx={{ fontSize: 18 }} />
                          }
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}>No files</Typography>
              )}
            </Box>
          </Box>
        )}

        {/* AddToBrandModal for compact view */}
        <AddToBrandModal
          open={openBrandModal}
          onClose={() => setOpenBrandModal(false)}
          fileData={selectedFileForBrand}
          jobId={jobId}
          onStatusChange={handleBrandStatusChange}
        />
      </Box>
    );
  }

  /* ===== STANDARD CARD VIEW ===== */
  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        p: 2,
        mt: 0,
        mb: 2.5,
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        bgcolor: '#fff',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'visible'
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '14px',
            }}
          >
            {label || schema.title}
          </Typography>

          {enabled !== false && (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <input
                id={`file-upload-${path}`}
                type="file"
                multiple
                hidden
                onChange={(e) => {
                  if (e.target.files?.length) handleFileChange(e.target.files);
                  e.target.value = "";
                }}
              />
              <label htmlFor={`file-upload-${path}`}>
                <Tooltip title="Upload from computer">
                  <IconButton component="span" size="small">
                    <AttachFileIcon sx={{ transform: 'rotate(45deg)', fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
              </label>
            </Box>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: files.length > 0 ? 4 : 2, maxHeight: '300px', overflowY: 'auto' }}>
          {files.length === 0 && (
            <Typography variant="body2" sx={{ color: '#888', width: '100%', fontStyle: 'italic', fontSize: '13px' }}>
              No files uploaded
            </Typography>
          )}
          {files.map((item, idx) => {
            const file = item.file;
            const fileName = getFileNameClean(item);

            return (
              <Box
                key={idx}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: 'calc(50% - 8px)',
                  minWidth: '200px',
                  bgcolor: 'background.paper',
                  boxShadow: '0px 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                <Box sx={{
                  width: 40,
                  height: 40,
                  mr: 1.5,
                  borderRadius: '4px',
                  overflow: 'hidden',
                  flexShrink: 0,
                  border: '1px solid #eee',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: '#f9f9f9'
                }}>
                  {(() => {
                    const url = file instanceof File ? URL.createObjectURL(file) : getFullUrl(file);
                    if (isImage(url)) {
                      return <img src={url} alt="pic" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
                    }
                    if (isPdf(url)) {
                      return <PdfThumbnail url={url} width={40} />;
                    }
                    return <AttachFileIcon sx={{ fontSize: 20, color: '#999', transform: 'rotate(45deg)' }} />;
                  })()}
                </Box>

                <Tooltip title={fileName}>
                  <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        mr: 1,
                        maxWidth: '120px',
                        fontWeight: 500,
                        color: typeof file === 'string' && file.startsWith('http') ? '#1976d2' : 'inherit',
                        textDecoration: typeof file === 'string' && file.startsWith('http') ? 'underline' : 'none',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        if (typeof file === 'string' && file.startsWith('http')) {
                          window.open(file, '_blank');
                        } else {
                          handleDownloadFile(item);
                        }
                      }}
                    >
                      {fileName}
                    </Typography>

                    {isCompleted && item.status && (
                      <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5 }}>
                        {item.status === 2 && (
                          <Tooltip title="Approved">
                            <CheckCircleIcon color="success" sx={{ fontSize: 18 }} />
                          </Tooltip>
                        )}
                        {item.status === 3 && (
                          <Tooltip title="Rejected">
                            <CancelIcon color="error" sx={{ fontSize: 18 }} />
                          </Tooltip>
                        )}
                        {item.status === 1 && (
                          <Tooltip title="Approval Requested">
                            <CheckBoxOutlineBlankIcon sx={{ fontSize: 18, color: grey[500] }} />
                          </Tooltip>
                        )}
                      </Box>
                    )}
                  </Box>
                </Tooltip>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {isCompleted && (
                    <Tooltip title={
                      item.add_to_brand ? "Manage in Library" : "Add to Library"
                    }>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenBrandModal(item, idx)}
                        sx={{ p: 0.5, color: item.add_to_brand ? '#05640a' : 'inherit' }}
                      >
                        {item.add_to_brand ? <LibraryAddedSvgIcon fontSize="small" /> : <LibraryAddSvgIcon fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                  )}

                  {enabled !== false && (
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteFile(idx)}
                      sx={{ p: 0.5, color: 'error.main' }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Footer Actions */}
      {enabled !== false && showLibraryLink && (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 'auto',
          pt: 1,
          borderTop: files.length > 0 || showLinkInput ? '1px solid #eee' : 'none'
        }}>
          {showLinkInput && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Paste File link here..."
                value={linkInput}
                onChange={(e) => setLinkInput(e.target.value)}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddLink();
                  }
                  if (e.key === 'Escape') setShowLinkInput(false);
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "32px",
                    fontSize: "12px",
                  }
                }}
              />
              <IconButton
                type="button"
                size="small"
                onClick={handleAddLink}
                disabled={!linkInput.trim()}
                sx={{
                  color: '#ff6100',
                  height: '32px',
                  width: '32px',
                  p: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: -0.5
                }}
              >
                <SendSvgIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#666',
              lineHeight: 1
            }}>
              <Typography
                component="span"
                sx={{
                  fontSize: '15px',
                  cursor: 'pointer',
                  '&:hover': { color: '#ff6100', textDecoration: 'underline' }
                }}
                onClick={() => setShowLinkInput(!showLinkInput)}
              >
                Link
              </Typography>

            </Box>
          </Box>
        </Box>
      )}

      <AddToBrandModal
        open={openBrandModal}
        onClose={() => setOpenBrandModal(false)}
        fileData={selectedFileForBrand}
        jobId={jobId}
        onStatusChange={handleBrandStatusChange}
      />
    </Box>
  );
};

export default withJsonFormsControlProps(FileWidget);
